/**
 * On a phone, tables with a header row are shown as one card per row (see "Phone" in styles.css). Each cell needs
 * its column name to show beside the value, so this copies the header text into a data-label on every cell and
 * marks the table as stackable. It watches the page so tables rendered later are labelled too.
 * Tables marked .matrix or .no-stack keep their columns and scroll sideways instead.
 */
function label(table: HTMLTableElement) {
  if (table.classList.contains('matrix') || table.classList.contains('no-stack')) return;
  const head = table.tHead?.rows[0];
  if (!head) return;
  const names: string[] = [];
  for (const th of Array.from(head.cells)) for (let i = 0; i < th.colSpan; i++) names.push((th.textContent ?? '').trim());
  table.classList.add('stackable');
  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      let col = 0;
      for (const td of Array.from(row.cells)) {
        const name = td.colSpan > 1 ? '' : names[col] ?? '';
        if (td.getAttribute('data-label') !== name) td.setAttribute('data-label', name);
        col += td.colSpan;
      }
    }
  }
}

export function startTableStacking() {
  let queued = false;
  const run = () => { queued = false; document.querySelectorAll<HTMLTableElement>('table.tbl').forEach(label); };
  const obs = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(run); } });
  obs.observe(document.body, { childList: true, subtree: true });
  run();
}
